module.exports = __webpack_public_path__ + "static/media/multipleroi 2.b0a58253.png";